<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button shape="round" fill="clear" @click="closeModal">
            <ion-icon slot="icon-only" :icon="close" />
          </ion-button>
        </ion-buttons>
        <ion-title>{{ $t("bookings.createTitle") }}</ion-title>
        <ion-buttons slot="primary">
          <ion-button color="secondary" id="nested-button">
            <country-flag :country="$i18n.locale === 'en' ? 'gb' : $i18n.locale" size="normal" />
          </ion-button>
          <ion-popover trigger="nested-button" :dismiss-on-select="true">
            <ion-content>
              <ion-list>
                <ion-item
                  :button="true"
                  :detail="false"
                  @click="setLang('es-ca')"
                >
                  <country-flag country="es-ca" size="normal" />&nbsp; &nbsp;
                  Català
                </ion-item>
                <ion-item :button="true" :detail="false" @click="setLang('es')">
                  <country-flag country="es" size="normal" />&nbsp; &nbsp;
                  Castellano
                </ion-item>
                <ion-item :button="true" :detail="false" @click="setLang('fr')">
                  <country-flag country="fr" size="normal" />&nbsp; &nbsp;
                  Français
                </ion-item>
                <ion-item :button="true" :detail="false" @click="setLang('en')">
                  <country-flag country="gb" size="normal" />&nbsp; &nbsp;
                  English
                </ion-item>
              </ion-list>
            </ion-content>
          </ion-popover>
        </ion-buttons>
        <div class="progress" :style="{ width: this.progress + '%' }"></div>
      </ion-toolbar>
    </ion-header>
    <crear-reserva v-show="activeFormIndex == index" :index="activeFormIndex" @back="tornar" :key="index" v-for="(form, index) of forms" v-model="forms[index]" :forms="forms" @add="afegirReserva"></crear-reserva>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  modalController,
  alertController,
} from "@ionic/vue";
import { close } from "ionicons/icons";
import { IonContent as content } from "@ionic/vue";
import CountryFlag from "vue-country-flag-next";
import CrearReserva from "./CrearReserva.vue";

export default defineComponent({
  setup() {
    return {
      close,
      modalController,
    };
  },
  components: {
    CrearReserva,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonPage,
    IonButtons,
    CountryFlag,
  },
  data: () => ({
    formBase: {
      send_deposit_email: true,
      dates: {
        start: null,
        end: null,
      },
      vehicle_type_id: null,
      addons: [],
      vehicles: [],
      payments: [],
      client: {
        client_name: null,
        client_id_doc: null,
        client_email: null,
        client_phone: null,
        client_address: null,
        client_country: null,
        disclaimer1: false,
        media_ids: [],
      },
      documentation: {
        id_front: [360],
        id_back: [360],
        driver_license_front: [360],
        driver_license_back: [360],
      },
      legal_signature: null,
      price: 0,
      total_price: 0,
      checkin_location_id: null,
      checkout_location_id: null,
    },
    forms: [],
    activeFormIndex: null
  }),
  mounted() {
    if (this.$route.query.locale) {
      this.$i18n.locale = this.$route.query.locale;
    }
    this.afegirReserva();
  },
  methods: {
    tornar() {
      this.activeFormIndex = this.activeFormIndex - 1;
      this.forms = this.forms.slice(0, -1)
    },
    afegirReserva() {
      const newLength = this.forms.push(Object.assign({}, this.formBase));
      this.activeFormIndex = newLength - 1;
    },
    async closeModal() {
      const alert = await alertController.create({
        header: this.$t("bookings.cancelConfirmationTitle"),
        message: this.$t("bookings.cancelConfirmationDesc"),
        buttons: [
          {
            text: this.$t("bookings.exit"),
            cssClass: "secondary",
            id: "confirm-button",
            handler: () => {
              modalController.dismiss();
              parent.postMessage(JSON.stringify({ action: "close" }), "*");
            },
          },
          {
            text: this.$t("bookings.cancel"),
            role: "cancel",
          },
        ],
      });
      await alert.present();

      const { role } = await alert.onDidDismiss();
      console.log("onDidDismiss resolved with role", role);
    },
    setLang(lang) {
      this.$i18n.locale = lang;
    },
  },
  computed: {
    progress() {
      return 0;
      // return (this.step * 100) / 9;
    },
  },
});
</script>

<style lang="scss" scoped>
.v-sheet.v-stepper {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}
.continue ion-button {
  float: right;
}
.price-col {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
    color: #0b5a85;
    position: relative;
    top: -1px;
}
ion-footer {
  background: white;
}
.payment-iframe {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  border: none;
}
.progress {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  height: 4px;
  background: #3982b6;
  transition: ease all 0.5s;
}
</style>
